<template>
  <div>
    <div class="text-xs-right">
      <div>
        <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>search</v-btn>
      </div>
      <importxlsx :loading="importloading" @onChange="onImport"></importxlsx>
      <v-btn :loading="exportloading" color="grey" outline @click="exportxlsx">
        <em class="fas fa-file-export" />
        &nbsp; Export&nbsp;
      </v-btn>
      <v-btn depressed color="primary" @click="addBranch">ADD</v-btn>
    </div>
    <v-pagination
      v-model="pageNumber"
      :total-visible="15"
      :length="pagelength"
      @input="changePage"
    ></v-pagination>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      hide-actions
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template #items="props">
        <tr>
          <td>
            {{ props.item.department_store_id }}
          </td>
          <td>
            {{ props.item.department_store }}
          </td>
          <td>
            {{ props.item.product_name }}
          </td>
          <td>
            {{ props.item.mkt_id || '-' }}
          </td>
          <td>
            {{ props.item.sub_mkt_id || '-' }}
          </td>
          <td>
            {{ props.item.sku }}
          </td>
          <td>
            {{ props.item.material_code }}
          </td>
          <td>
            {{ props.item.price }}
          </td>
          <td>
            {{ props.item.points }}
          </td>
          <td class="text-xs-right">
            <v-btn icon @click="editBranch(props.item)"> <v-icon>edit</v-icon></v-btn>
            <v-btn icon @click="deleteProduct(props.item)"> <v-icon>delete</v-icon></v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div>
      <v-dialog v-model="showEdit" persistent width="550px">
        <v-card v-if="showEdit">
          <ProductEdit
            :edittype="edittype"
            :editdata="editdata"
            @onsave="onsave"
            @close="showEdit = false"
          ></ProductEdit>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-model="qrdialog" width="350px" persisten>
      <v-card v-if="qrdialog" class="text-xs-center pb-4">
        <div class="text-xs-right">
          <v-btn icon small @click="qrdialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div style="font-size: 28px; font-weight: 600">
          {{ qrdata.department_store }}
        </div>
        <div style="color: black">
          {{ qrdata.branch }}
        </div>
        <div>
          <v-img class="mx-auto" width="200px" :src="qrdata.qr_code"></v-img>
        </div>
        <div>
          <a download="filename.jpeg" :href="qrdata.qr_code">
            <v-btn color="primary" @click="gotolink(qrdata.qr_code)">Download</v-btn></a
          >
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showsearch" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn icon @click="showsearch = false"><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('สินค้า') }}</label>
                <input v-model="filter.product_name" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('SKU') }}</label>
                <input v-model="filter.sku" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>MKT</label>
                <input v-model="filter.mkt_id" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>Sub MKT</label>
                <input v-model="filter.sub_mkt_id" class="form-control" type="text" />
              </v-flex>

              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('Mat code') }}</label>
                <input v-model="filter.material_code" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm12 class="pa-1">
                <label>{{ $t('ชื่อห้าง') }}</label>
                <!-- <input v-model="filter.department_store" class="form-control" type="text" /> -->
                <v-autocomplete
                  v-model="filter.department_store"
                  :data-vv-as="$t('สาขา')"
                  name="department_store"
                  placeholder="ห้าง"
                  :items="departmentStoreOptions"
                  single-line
                  outline
                  hide-details
                  clearable
                />
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn outline color="grey" @click="clearsearch">Clear</v-btn>
            <v-btn color="primary" @click="onsearch">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import { mapGetters } from 'vuex'
import ProductEdit from './ProductEdit.vue'
import VueQr from 'vue-qr'
import * as XLSX from 'xlsx'
import toaCrmApi from '@/api/toa-crm'

export default {
  components: {
    ProductEdit,
    VueQr,
    importxlsx,
    exportxlsx
  },
  data() {
    return {
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      qrlink: '',
      qrdialog: false,
      importloading: false,
      qrdata: '',
      showEdit: false,
      editdata: '',
      edittype: '',

      pagination: { rowsPerPage: -1, sortBy: 'branch_id' },
      columnName: '',
      items: [],
      filter: {
        product_name: '',
        sku: '',
        material_code: '',
        department_store: '',
        mkt_id: '',
        sub_mkt_id: ''
      },
      exportloading: false,
      showsearch: false,
      loading: false,
      headers: [
        { text: 'รหัสห้าง', value: 'department_store_id' },
        { text: 'ชื่อห้าง', value: 'department_store' },
        { text: 'ชื่อสินค้า', value: 'product_name' },
        { text: 'MKT', value: 'mkt_id' },
        { text: 'Sub MKT', value: 'sub_mkt_id' },
        { text: 'SKU', value: 'sku' },
        { text: 'Material Code', value: 'material_code' },
        { text: 'ราคา', value: 'price' },
        { text: 'คะแนนที่ได้', value: 'points' },
        { text: '', value: '' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    },
    branchMasterData() {
      return this.$store.state.toacrmbranch
    },
    departmentStoreOptions() {
      let options = []
      if (this.branchMasterData) {
        this.branchMasterData.forEach((el) => {
          if (![...options].includes(el.department_store)) {
            options.push(el.department_store)
          }
        })
      }
      return options
    }
  },
  mounted() {
    this.getProduct()
    this.getMasterDataBranch()
  },
  methods: {
    deleteProduct(item) {
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            this.loading = true
            var data = {
              ...item,
              pageid: this.selectedBot.pageid
            }
            api.deleteproducttoacrm(data, (err, response) => {
              this.loading = false
              if (response.responsecode == 200) {
                this.getProduct()
                this.$swal.fire({
                  type: 'success',
                  text: 'สำเร็จ'
                })
              }
            })
          }
        })
    },
    clearsearch() {
      this.filter = {
        branchId: '',
        branchToaId: '',
        departmentStore: ''
      }
      this.onsearch()
      this.showsearch = false
    },
    onsearch() {
      this.pageNumber = 1
      this.offset = 0
      this.getProduct()
      this.showsearch = false
    },
    async exportxlsx() {
      var data = {
        pageid: this.selectedBot.pageid
        // branchId: this.filter.branchId, // filter รหัสสาขาของห้าง
        // branchToaId: this.filter.branchToaId, // filter รหัสสาขา toa
        // departmentStore: this.filter.departmentStore, // filter ชื่อห้าง
        // branch: this.filter.branch, // filter ชื่อสาขา
        // offset: this.offset,
      }
      this.exportloading = true
      api.getproducttoacrm(data, (err, response) => {
        console.log('response: ', response)
        var exporteddata = response.data

        var json = exporteddata.map((el) => {
          return {
            รหัสห้าง: el.department_store_id,
            ชื่อห้าง: el.department_store,
            ชื่อสินค้า: el.product_name,
            MKT: el.mkt_id,
            'Sub MKT': el.sub_mkt_id,
            SKU: el.sku,
            'Material Code': el.material_code,
            ราคา: el.price,
            คะแนนที่ได้: el.points
          }
        })

        const dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, 'exportedproduct' + '.xlsx')
        this.exportloading = false
      })
    },
    onImport(item) {
      this.importloading = true
      var data = {
        pageid: this.selectedBot.pageid,
        files: item[0]
      }
      api.importproducttoacrm(data, async (err, response) => {
        this.importloading = false
        await this.$swal.fire({
          text: 'สำเร็จ',
          type: 'success'
        })
        this.getProduct()
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp !== val) {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getProduct()
      }
    },
    editBranch(item) {
      this.editdata = item
      this.edittype = 'edit'
      this.showEdit = true
    },
    onsave() {
      this.showEdit = false
      this.getProduct()
    },
    gotolink(link) {
      this.$nextTick(() => {
        window.location.href = link
      })
      // location.assign(this.qrlink)
    },
    showQrcode(item) {
      this.qrdialog = true
      this.qrdata = item
    },
    addBranch() {
      this.edittype = 'create'
      this.showEdit = true
    },
    getProduct() {
      var data = {
        pageid: this.selectedBot.pageid,
        limit: this.limit,
        offset: this.offset
      }
      for (const key in this.filter) {
        if (this.filter[key]) {
          Object.assign(data, { [key]: this.filter[key] })
        }
      }
      this.loading = true
      api.getproducttoacrm(data, (err, response) => {
        this.loading = false
        this.items = response.data
        this.total = response.total
      })
    },
    async getMasterDataBranch() {
      const vm = this
      try {
        const data = {
          pageid: vm.selectedBot.pageid
        }

        const response = await toaCrmApi.postGetAllBranch({ data: data })

        if (response && response.status === 200) {
          vm.$store.state.toacrmbranch = response.data.data
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/Product.vue